"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { FormkitSad } from "@/assets/icons/formkit-sad";

export default function NotFound() {
  return (
    <main>
      <BannerSection title="Page non trouvée" />

      <section className="relative isolate overflow-hidden bg-[linear-gradient(180deg,_#fef6f6_0%,_#fde8e8_50%,_#f8dede_100%)] px-4 py-20 text-black ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <div className="pointer-events-none absolute -right-16 -top-20 h-56 w-56 rounded-full bg-primary/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-16 -left-20 h-52 w-52 rounded-full bg-[#d89696]/25 blur-3xl" />

        <div className="relative mx-auto max-w-3xl rounded-3xl border border-black/10 bg-white/70 p-8 text-center shadow-[0_18px_40px_rgba(0,0,0,0.08)] backdrop-blur-sm md:p-10">
          <div className="bg-primary/12 mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full">
            <FormkitSad className="h-8 w-8 text-primary" />
          </div>

          <p className="text-2xl font-semibold md:text-3xl">Erreur 404</p>
          <p className="mt-3 text-base leading-relaxed text-black/80 md:text-lg">
            La page que vous recherchez n&apos;existe pas ou a été déplacée.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <PrimaryButton
              text="Retourner à l'accueil"
              navigateTo="/"
              variant="black"
            />
            <PrimaryButton text="Nous contacter" navigateTo="/#contact" />
          </div>
        </div>
      </section>
    </main>
  );
}
